import React, { useState, useRef, useEffect } from "react";
import Pagination from "react-js-pagination";
import { ContentTable } from "./ContentTable";
import { useSelector, useDispatch } from "react-redux";
import { updateDataSearchTaiKhoanIcloud } from "../../../actions/QuanTriHeThong";
import { AddTaiKhoanDesktopBtn } from "./AddTaiKhoanDesktopBtn";

export const TableDanhSach = ({ dataDanhSach, onSearch }) => {
  const dispatch = useDispatch();
  const dataSearch = useSelector((state) => state.dataSearchTaiKhoanIcloud);
  const handlePageChange = (pageNumber) => {
    dataSearch.iPageIndex = pageNumber;
    dispatch(
      updateDataSearchTaiKhoanIcloud({
        ...dataSearch,
        iPageIndex: pageNumber,
      })
    );
    onSearch();
  };
  return (
    <>
      <div
        className="card border-light mb-3 card-v2"
        style={{
          marginLeft: "15px",
          marginRight: "15px",
        }}
      >
        <div style={{ paddingLeft: "20px", paddingTop: "20px" }}>
          <div className="color7-bold" >
            <div >
              Số hợp đồng đang được gán cho tk ICL:{" "}
              <span>{dataDanhSach.iTotal1}</span>
            </div>
            <div >
              Số hợp đồng còn được tạo:{" "}
              {dataDanhSach.iTotal * 5 - dataDanhSach.iTotal1}
            </div>
          </div>
          <AddTaiKhoanDesktopBtn data={""} onSearch={onSearch} />
        </div>
        <div className="card-body card-body-v2">
          <div className="Left808x200 Table-main-new">
            <div className="table-mobile sticky-table-bh1 table-mobile-hover">
              <div className="custom-table-wrapper">
                <div className="table-headers">
                  <div className="custom-table-header flex-basis-5 flex-basis-6-sm">
                    <p className="text-center">
                      STT
                      <br />{" "}
                      <span className="color-do-bold">[ {dataDanhSach.iTotal} ]</span>
                    </p>
                  </div>
                  <div className="custom-table-header flex-basis-10 flex-basis-20-sm">
                    <p className="text-left">Tên tài khoản</p>
                  </div>
                  <div className="custom-table-header flex-basis-10 flex-basis-20-sm">
                    <p className="tab-header  text-center">Mật khẩu</p>
                  </div>
                  <div className="custom-table-header flex-basis-10 flex-basis-20-sm">
                    <p className="tab-header  text-center">Số điện thoai</p>
                  </div>

                  <div className="custom-table-header flex-basis-10 flex-basis-20-sm">
                    <p className="tab-header  text-center">
                      Số hợp đồng liên kết
                    </p>
                  </div>
                  <div className="custom-table-header flex-basis-10 flex-basis-20-sm">
                    <p className="tab-header  text-center">Trạng thái</p>
                  </div>
                  <div className="custom-table-header flex-basis-15 flex-basis-10-sm">
                    <p className="tab-header left-center">Thao tác</p>
                  </div>
                </div>

                <div className="custom-table-body">
                  {typeof dataDanhSach.List != "undefined" &&
                    dataDanhSach.List.length > 0 && (
                      <ContentTable
                        dataDanhSach={dataDanhSach}
                        onSearch={onSearch}
                      />
                    )}
                  {typeof dataDanhSach.List === "undefined" ||
                    (dataDanhSach.List.length === 0 && (
                      <div>Không có dữ liệu</div>
                    ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="card border-light mb-3 card-v2"
        style={{
          marginLeft: "15px",
          marginRight: "15px",
        }}
      >
        <div className="card-body card-body-v2">
          <div className="row">
            <div className="col-sm-12 col-md-6">
              <span className="color7">
                {dataDanhSach.iTotal === 0 ? (
                  "Hiển thị 0 - 0 / Tổng số 0"
                ) : (
                  <>
                    Hiển thị{" "}
                    {(dataSearch.iPageIndex - 1) * dataSearch.iPageSize + 1} -{" "}
                    {Math.min(
                      dataSearch.iPageIndex * dataSearch.iPageSize,
                      dataDanhSach.iTotal
                    )}{" "}
                    / Tổng số {dataDanhSach.iTotal}
                  </>
                )}
              </span>
            </div>
            <div className="col-sm-12 col-md-6">
              <div
                className={
                  "paniation-new paniation-new1 d-flex justify-content-center " +
                  (dataDanhSach.iTotal === 0 ? "hidden" : "")
                }
                style={{ float: "right" }}
              >
                <nav aria-label="Page navigation">
                  <Pagination
                    activePage={dataSearch.iPageIndex}
                    itemsCountPerPage={dataSearch.iPageSize}
                    totalItemsCount={dataDanhSach.iTotal}
                    pageRangeDisplayed={5}
                    onChange={handlePageChange}
                    itemClass="page-item border-none"
                    linkClass="page-link border-none"
                    activeClass="active"
                  />
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
